import script from "./AboutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutPage.vue?vue&type=script&setup=true&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=03836c24&scoped=true&lang=css"
import "./AboutPage.vue?vue&type=style&index=1&id=03836c24&coped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03836c24"]])

export default __exports__